<template lang="html">
  <div class="center">
    <div class="inner">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>

<style lang="css" scoped>
  .center {
    position: absolute;
    width: 100%;
    /* background: #303133; */
    background: #f5f6fa;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .inner {
    width: 400px;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.07);
  }
</style>
